<template>
  <div>

    <xolas-table
        :title="title"
        url="/contractors"
        :fields="fields"
        table-ref="contractors-table"
        layer-component="siteContractor"
        :layer-args="{ id: 'id' }" />

 </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {
  mixins: [SiteMixins],

  props: {

    siteData: {
      type: Object,
      required: false,
      default: null
    },

    sharerId: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: 'Contractors Invoices'
    },

    showAmounts: {
      type: Boolean,
      default: true
    },

    noAdd: {
      type: Boolean,
      default: true
    },

    noDelete: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },



  data () {

    return {

      // Column min-widths tuned to match the legacy vuetable layout (XOL-232).
      // el-table otherwise distributes every column equally, starving Site Name
      // (wraps) and leaving an empty admin-action column. Paired with the scoped
      // zero-horizontal-cell-padding below (dev's <td> used `padding: 12px 0`).
      fields: [
        {
          name: 'site.siteId',
          title: 'Site ID',
          minWidth: 200
        },
        {
          name: 'site.siteName',
          title: 'Site Name',
          minWidth: 270
        },
        {
          name: 'contractor.shortName',
          title: 'Short Name',
          minWidth: 150
        },
        {
          name: 'type',
          title: 'Type',
          minWidth: 160,
          sortField: 'type'
        },
        {
          name: 'summary',
          title: 'Summary',
          minWidth: 120,
          sortField: 'summary',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'started',
          title: 'Started',
          minWidth: 95,
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'ended',
          title: 'Ended',
          minWidth: 85,
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          minWidth: 100,
          callback: this.formatNumber,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: 'Tax',
          minWidth: 70,
          callback: this.formatNumber,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          minWidth: 85,
          callback: this.formatNumber,
          visible: this.showTax()
        }
      ]

  }

  } // data

}
</script>

<style scoped>
/* XOL-232: match the legacy vuetable cell box — its <td> used `padding: 12px 0`
   (zero horizontal). el-table wraps cell content in a .cell with 10px L/R padding,
   which (combined with equal column distribution) pushed the columns past the
   table width and wrapped Site Name. Zero the horizontal padding and let dense
   headers wrap, so the dev-matched min-widths fit and rows stay single-line. */
::v-deep .el-table th .cell,
::v-deep .el-table td .cell {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .el-table th .cell {
  white-space: normal;
  line-height: 1.25;
}
</style>
